import { gql } from '@apollo/client'

export default gql`
  mutation UpdateCampaignNote($input: UpdateCampaignNoteInput!) {
    updateCampaignNote(input: $input) {
      success
    }
  }
`
